import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import Button from "../../../components/button/Button";
import styles from "./RicercaNav.module.css"
import Utils from "../../../utils/Utils";
import Calendar from "../../../components/calendar/Calendar";
import RadioButton from "../../../components/radiobutton/RadioButton";
import SelectAutocomplete from "../../../components/selectAutocomplete/SelectAutocomplete";
import CheckBox from "../../../components/checkbox/CheckBox";
import $ from 'jquery'
import SessioneUtente from "../../../sessionManager/SessioneUtente";
import Ruoli from "../../../utils/Ruoli.json";
import OggettiUtili from "../../../utils/OggettiUtili.json";


class RicercaNav extends Component {

    state = {
        boxes: [],
        malattie: JSON.parse(sessionStorage.getItem("malattie")),
        tipoData: true,
        dataDa: "",
        dataA: "",
        segnalazione: true,
        possibile: true,
        probabile: true,
        confermato: true,
        ulssNotifica: ["all"],
        ulssAssistenza: ["all"]
    }

    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this)
        this.riceviValoreMultiselect = this.riceviValoreMultiselect.bind(this)
        this.renderSelect = this.renderSelect.bind(this)
    }

    componentDidMount() {
        let stato = this.props.filtri.stato

        if (stato) {
            for (const option of document.querySelectorAll('#malattia option')) {
                option.setAttribute('selected', 'selected');
            }
            if (SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Regionale.descrizione) {
                for (const option of document.querySelectorAll('#ulssNotifica option')) {
                    option.setAttribute('selected', 'selected');
                }
                for (const option of document.querySelectorAll('#ulssAssistenza option')) {
                    option.setAttribute('selected', 'selected');
                }
            }

            stato["malattia"] = ["all"]
            stato["tipoData"] = true
            stato["ulssNotifica"] = ["all"]
            stato["ulssAssistenza"] = ["all"]
            stato["segnalazione"] = true
            stato["possibile"] = true
            stato["probabile"] = true
            stato["confermato"] = true

            $(document).ready(function () {
                $('.selectpicker').selectpicker('refresh')
            });
        }

    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState != this.state) {
            $(document).ready(function () {
                $('.selectpicker').selectpicker('refresh')
            });
        }
    }

    riceviValoreMultiselect(event, field) {
        let stato = this.props.filtri.stato
        let selectedMalattie = []


        if (event.target.options[0].selected == true &&
            event.currentTarget && event.currentTarget.selectedOptions[0] &&
            event.currentTarget.selectedOptions[0].value == "" &&
            event.currentTarget.selectedOptions.length == 1) {
            for (let i = 0; i < event.target.options.length - 1; i++) {
                event.target.options[i + 1].selected = true
            }
            stato[field] = ["all"]
        } else if (event.target.options[0].selected == false &&
            event.target.options.length == event.currentTarget.selectedOptions.length + 1 &&
            ((this.props.filtri.stato.malattia == "all" && field == "malattia") ||
            (this.props.filtri.stato.ulssAssistenza == "all" && field == "ulssAssistenza") ||
            (this.props.filtri.stato.ulssNotifica == "all" && field == "ulssNotifica"))) {
            for (let i = 0; i < event.target.options.length; i++) {
                event.target.options[i].selected = false
            }
            stato[field] = [];

            $(document).ready(function () {
                $('.selectpicker').selectpicker('refresh')
            });
        } else if (event.target.options[0].selected == false &&
            event.currentTarget && event.currentTarget.selectedOptions[0] &&
            event.currentTarget.selectedOptions[0].value == "" &&
            event.currentTarget.selectedOptions.length != 1) {
            for (let i = 0; i < event.target.options.length - 1; i++) {
                event.target.options[i + 1].selected = false
            }
            stato[field] = []
        } else if ((this.props.filtri.stato.malattia == "all" && field == "malattia") ||
            (this.props.filtri.stato.ulssAssistenza == "all" && field == "ulssAssistenza") ||
            (this.props.filtri.stato.ulssNotifica == "all" && field == "ulssNotifica")) {

            if (event.target.options.length == event.currentTarget.selectedOptions.length + 1) {
                for (let i = 0; i < event.currentTarget.selectedOptions.length; i++) {
                    selectedMalattie[i] = event.currentTarget.selectedOptions[i].value
                }
                if (selectedMalattie != "") {
                    for (let i = 0; i < event.target.options.length - 1; i++) {
                        if (selectedMalattie === event.currentTarget.options[i + 1].value) {
                            if (event.target.options[i + 1].selected = false) {
                                event.target.options[i + 1].selected = true
                            } else {
                                event.target.options[i + 1].selected = false
                            }
                        }

                    }
                    event.target.options[0].selected = false
                }
                stato[field] = selectedMalattie

            } else {
                for (let i = 0; i < event.target.options.length; i++) {
                    event.target.options[i].selected = false
                }
                stato[field] = []
            }

            $(document).ready(function () {
                $('.selectpicker').selectpicker('refresh')
            });

        } else if ((this.props.filtri.stato.malattia !== "all" && field == "malattia") ||
            (this.props.filtri.stato.ulssAssistenza != "all" && field == "ulssAssistenza") ||
            (this.props.filtri.stato.ulssNotifica != "all" && field == "ulssNotifica")) {

            if (event.target.options.length != event.currentTarget.selectedOptions.length) {

                if (event.target.options[0].selected) {
                    {
                        for (let i = 0; i < event.target.options.length - 1; i++) {
                            event.target.options[i + 1].selected = true
                        }
                        stato[field] = ["all"]
                    }
                } else {

                    for (let i = 0; i < event.currentTarget.selectedOptions.length; i++) {
                        selectedMalattie[i] = event.currentTarget.selectedOptions[i].value
                    }
                    if (selectedMalattie != "") {
                        for (let i = 0; i < event.target.options.length - 1; i++) {
                            if (selectedMalattie === event.currentTarget.options[i + 1].value)
                                event.target.options[i + 1].selected = false
                        }
                        event.target.options[0].selected = false
                    }
                    if (event.target.options.length == event.currentTarget.selectedOptions.length + 1) {
                        event.target.options[0].selected = true
                        stato[field] = ["all"]
                    } else
                        stato[field] = selectedMalattie

                }
            } else {
                for (let i = 0; i < event.target.options.length; i++) {
                    event.target.options[i].selected = false
                }
                stato[field] = []
            }

            $(document).ready(function () {
                $('.selectpicker').selectpicker('refresh')
            });

        } else {
            if (event.currentTarget.selectedOptions &&
                event.currentTarget.selectedOptions[0] &&
                event.currentTarget.selectedOptions[0].selected == true &&
                event.currentTarget.selectedOptions[0].value == "") {
                for (let i = 0; i < event.target.options.length - 1; i++) {
                    event.target.options[i + 1].selected = true
                }
                stato[field] = ["all"]
            } else {
                let selectedMalattie = []
                for (let i = 0; i < event.currentTarget.selectedOptions.length; i++) {
                    selectedMalattie[i] = event.currentTarget.selectedOptions[i].value
                }
                stato[field] = selectedMalattie
            }
        }

        this.props.filtri.setStatePadre({filtri: stato, sendRequest: false})
        this.setState({[field]: stato[field]})
    }

    riceviValore(field, event) {
        let stato = this.props.filtri.stato

        if (event) {
            if (event.target.value === "true") {
                stato[field] = true
                this.setState({[field]: true})
            } else if (event.target.value === "false") {
                stato[field] = false
                this.setState({[field]: false})
            } else {
                stato[field] = event.target.value
                this.setState({[field]: event.target.value})
            }
        } else {
            if (field.currentTarget.id === "ulssNotifica" || field.currentTarget.id === "ulssAssistenza") {
                if (field.currentTarget.value === "1") {
                    stato[field.currentTarget.id] = [SessioneUtente.getInstance().ulss]
                } else if (field.currentTarget.value === "2") {
                    let arrayUlss = field.currentTarget.id === "ulssAssistenza" ?
                        Utils.getArrayUlssResidenza() :
                        Utils.mapToArray(OggettiUtili.ulssMap)
                    stato[field.currentTarget.id] = arrayUlss
                        .map((ulss) => ulss.codice)
                        .filter((codice) => codice !== SessioneUtente.getInstance().ulss)
                } else {
                    stato[field.currentTarget.id] = ["all"]
                }
            } else {
                stato[field.currentTarget.id] = [field.currentTarget.value];
            }
        }

        this.props.filtri.setStatePadre({filtri: stato, sendRequest: false})

    }

    trasformMapMalattie(arrayOption, descrizione) {
        let array = Utils.mapToArray(arrayOption)
        let addRicerca = {descrizione: descrizione, codDesc: descrizione, codice: ""}

        array.unshift(addRicerca)

        return array
    }

    trasformArrayUlss(arrayUlss, descrizione) {
        let array = arrayUlss.slice()

        array.unshift({descrizione: descrizione, codDesc: descrizione, codice: ""})

        return array
    }

    renderSelect(id, field) {
        const isRegionale = SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Regionale.descrizione
        const listaUlss = field === "ulssAssistenza" ?
            Utils.getArrayUlssResidenza() :
            Utils.mapToArray(OggettiUtili.ulssMap)

        let renderBoxSelect = (

            <SelectAutocomplete
                id={id}
                field={field}
                onChange={isRegionale ? (e) => this.riceviValoreMultiselect(e, field) : this.riceviValore}
                multiple={isRegionale ? "true" : "false"}
                ricerca={isRegionale}

                defaultValue={this.state[field]}
                functionMap={!isRegionale ?
                    Utils.mapToArray(OggettiUtili.UlssNotifica).map((oggetto) => {
                        return (<option key={oggetto.codice} value={oggetto.codice}>{oggetto.descrizione}</option>)
                    }) :
                    this.trasformArrayUlss(listaUlss, "Tutte le ULSS").map((oggetto) => {
                        return (<option key={oggetto.codice} value={oggetto.codice}>{oggetto.descrizione}</option>)
                    })}
            >
            </SelectAutocomplete>
        )

        return renderBoxSelect
    }

    disableButtonVisualizza(){
        if((!this.state.confermato &&
            !this.state.possibile &&
            !this.state.probabile &&
            !this.state.segnalazione ) ||
            this.state.ulssNotifica.length == 0 ||
            this.state.ulssAssistenza.length == 0 ) return true
        else return false
    }

    render() {
        const {t} = this.props;

        const sezione1 = (
            this.props.filtri.rows ?
                <div className={"col-lg-5"}>
                    <div className={"row"}>
                        <div className={"col-lg-6"}>
                            <RadioButton id={this.props.filtri.rows["tipoData"].id1}
                                         name={this.props.filtri.rows["tipoData"].name}
                                         label={"Data di inizio sintomi"}
                                         newRadio={true}
                                         onClick={this.riceviValore}
                                         style={{color: "black", fontSize: "16px", fontWeight: "bold"}}
                                         smallLabel={true}
                                         value={true}
                                         checked={this.state.tipoData === true}
                            ></RadioButton>
                        </div>
                        <div className={"col-lg-6"}>
                            <RadioButton id={this.props.filtri.rows["tipoData"].id2}
                                         name={this.props.filtri.rows["tipoData"].name}
                                         label={"Data di segnalazione"}
                                         newRadio={true}
                                         onClick={this.riceviValore}
                                         style={{color: "black", fontSize: "16px", fontWeight: "bold"}}
                                         smallLabel={true}
                                         value={false}
                                         checked={this.state.tipoData === false}
                            ></RadioButton>
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col-lg-6"}>
                            <Calendar id={this.props.filtri.rows["data"].id}
                                      value={this.state.dataDa}
                                      field={this.props.filtri.rows["data"].field}
                                      onChange={this.riceviValore}
                                      newCalendar={true}
                                      placeholder={this.props.filtri.rows["data"].placeholder ? this.props.filtri.rows["data"].placeholder : ""}
                                      errorMessage={this.state.dataDa && Utils.isDateInValid(this.state.dataDa) ? "Data non valida" : ""}
                                      error={Utils.isDateInValid(Utils.transformDateForBackend(this.state.dataDa), "-") &&
                                      this.state.dataDa !== ""}
                            />
                        </div>
                        <div className={"col-lg-6"}>
                            <Calendar id={this.props.filtri.rows["data"].id1}
                                      value={this.state.dataA}
                                      field={this.props.filtri.rows["data"].fieldRadio}
                                      onChange={this.riceviValore}
                                      newCalendar={true}
                                      placeholder={this.props.filtri.rows["data"].placeholder1 ? this.props.filtri.rows["data"].placeholder1 : ""}
                                      errorMessage={this.state.dataA && Utils.isDateInValid(this.state.dataA) ? "Data non valida" : ""}
                                      error={Utils.isDateInValid(Utils.transformDateForBackend(this.state.dataA), "-") &&
                                      this.state.dataA !== ""}
                            />
                        </div>
                    </div>
                </div> : <></>
        );

        const sezione2 = (
            this.props.filtri.rows ?
                <div className="col-lg-2">
                    <p className={styles.align}>{this.props.filtri.rows["ulssNotifica"].text}</p>
                    <div style={{marginTop: "12px"}}>
                        {this.renderSelect(this.props.filtri.rows["ulssNotifica"].id, this.props.filtri.rows["ulssNotifica"].field)}
                    </div>
                </div>
                : <></>
        );


        const sezione3 = (
            this.props.filtri.rows ?
                <div className="col-lg-2"><p className={styles.align}>{this.props.filtri.rows["ulssAssistenza"].text}</p>
                    <div
                        style={{marginTop: "12px"}}>{this.renderSelect(this.props.filtri.rows["ulssAssistenza"].id, this.props.filtri.rows["ulssAssistenza"].field)}</div>
                </div>
                : <></>
        );

        const sezione4 = (
            this.props.filtri.rows ?
                <div style={{marginLeft: "1rem"}}>
                    <p className={styles.align}>{"Stato della segnalazione"}</p>
                    <div className={"row"}>
                        <div className="col-lg-6">
                            <CheckBox id={this.props.filtri.rows["checkStato"].id1}
                                      isRadio={false}
                                      checked={this.state.segnalazione}
                                      fontColor={"black"}
                                      newCheckbox={true}
                                      text={"Segnalazione"}
                                      fontWeight={"bold"}
                                      fontSize={"12px"}
                                      onChange={this.riceviValore}
                            >
                            </CheckBox>
                        </div>
                        <div className="col-lg-6">
                            <CheckBox id={this.props.filtri.rows["checkStato"].id2}
                                      isRadio={false}
                                      checked={this.state.possibile}
                                      fontColor={"black"}
                                      newCheckbox={true}
                                      text={"Possibile"}
                                      fontSize={"12px"}
                                      fontWeight={"bold"}
                                      onChange={this.riceviValore}
                            >
                            </CheckBox>
                        </div>
                    </div>
                    <div className={"row"} style={{marginTop: "-1rem"}}>
                        <div className="col-lg-6">
                            <CheckBox id={this.props.filtri.rows["checkStato"].id3}
                                      isRadio={false}
                                      checked={this.state.probabile}
                                      fontColor={"black"}
                                      newCheckbox={true}
                                      text={"Probabile"}
                                      fontSize={"12px"}
                                      fontWeight={"bold"}
                                      onChange={this.riceviValore}
                            >
                            </CheckBox>
                        </div>
                        <div className="col-lg-6">
                            <CheckBox id={this.props.filtri.rows["checkStato"].id4}
                                      isRadio={false}
                                      checked={this.state.confermato}
                                      fontColor={"black"}
                                      newCheckbox={true}
                                      text={"Confermato"}
                                      fontSize={"12px"}
                                      fontWeight={"bold"}
                                      onChange={this.riceviValore}
                            >
                            </CheckBox>
                        </div>
                    </div>

                </div> : <></>
        );

        const sezione5 = (
            this.props.filtri.rows ?
                <div>
                    <div className="col-lg-9">
                        <p className={styles.align}>{"Malattia:"}</p>
                        <div style={{marginTop: "16px"}}>
                            <SelectAutocomplete
                                id={this.props.filtri.rows["malattia"].id}
                                field={this.props.filtri.rows["malattia"].field}
                                multiple={"true"}
                                onChange={(e) => this.riceviValoreMultiselect(e, this.props.filtri.rows["malattia"].field)}
                                functionMap={this.trasformMapMalattie(this.state.malattie, "Tutte le malattie").map((oggetto) => {
                                    return (<option value={oggetto.codice}>{oggetto.codDesc}</option>)
                                })}
                                ricerca={true}
                            >
                            </SelectAutocomplete>
                        </div>
                    </div>
                </div> : <></>
        );

        const button = (
            this.props.filtri.rows ?
                <div className={styles.button}>
                    <div className="col-lg-6">
                        <Button className="btnBlu " id={"visualizza"}
                                text={"Visualizza report"}
                                onClick={this.props.filtri.applicaFiltri}
                                style={{height: "2rem", width: "10rem", marginTop: "1rem"}}
                                disabled={this.disableButtonVisualizza()}
                        ></Button>
                    </div>
                </div> : <></>
        );

        return (

            <div>
                <p id={"title"} style={{fontWeight: "bold", marginTop: "1rem"}}>{"Periodo di riferimento"}</p>
                <div className={"row"}>
                    {sezione1}
                    {sezione2}
                    {sezione3}
                    {sezione4}
                </div>
                <div style={{paddingBottom: "1rem"}}>
                    {sezione5}
                    {button}
                </div>

            </div>
        );
    }

}

export default withTranslation('common')(RicercaNav);
